<div class="timesheet-container">
  <div class="header">
    <div class="sec-title">
      <span class="hdr-ic"><i class="material-icons">schedule</i></span>
      <div class="sec-title-txt">
        <h2>Timesheets</h2>
        <span class="sec-sub">Monthly hours &amp; approval status</span>
      </div>
    </div>
    <div class="timesheet-details-search">
      <div class="search-child">
        <emerald-input
          [label]="'Search'"
          [trailingIcon]="'search'"
          (keyup)="searchTimesheet($event)"
          [value]="filterValue">
          <emerald-icon
            *ngIf="filterValue?.length && filterValue.length > 0"
            [icon]="'close'"
            (click)="clearInput()">
          </emerald-icon>
        </emerald-input>
      </div>
      <div class="select-container">
        <select class="native-month" aria-label="Month" (change)="onMonthSelect($any($event.target).value)">
          <option *ngFor="let opt of monthOptions" [value]="opt.label" [selected]="opt.selected">{{ opt.label }}</option>
        </select>
        <emerald-menu
          [opened]="opened"
          [position]="'bottom_end'"
          [targetElement]="navTemplate"
          [menuTemplate]="menuTemplate"
          (openChange)="opened = $event"
        ></emerald-menu>
        <ng-template #navTemplate>
          <emerald-button
            [label]="'Filter'"
            [size]="'Small'"
            [type]="'Secondary'"
            [icon]="'filter_list'"
            [iconPosition]="'Left'"
            (onClick)="this.opened = !this.opened"
          ></emerald-button>
        </ng-template>
        <ng-template #menuTemplate>
          <app-vendor-timesheet-filter
            [vendorTimesheetData]="data"
            (resetFilter)="resetFilter($event)"
            (applyFilter)="applyFilter($event)"
            (applyFilterCriteria)="onFilterCriteriaReceived($event)"
          ></app-vendor-timesheet-filter>
        </ng-template>
      </div>
      <emerald-button
        [label]="'Download'"
        [type]="'Secondary'"
        [icon]="'download'"
        [disabled]="selectedRows.length === 0"
        (onClick)="download()"
      >
      </emerald-button>
      <div>
        <emerald-button
          [label]="'Submit'"
          [type]="'Primary'"
          [disabled]="isSubmitDisabled()"
              (onClick)="openSubmitConfirmation()">
        </emerald-button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="displayData?.length; else noDataTemplate">
    <emerald-datatable
      [columnDefs]="columnDefs"
      [rowData]="displayData"
      [paginationParams]="paginationParams"
      [allowResizeColumns]="true"
      [isRowSelectable]="isRowSelectableFunction"
      (onRowSelect)="onRowSelected($event)"
      [customCellTemplate]="{
        select: customSelectColumn,
        employeeName: customNameColumn,
        employeeStatus: customEmployeeStatusColumn,
        calendar: customCalenderColumn,
        billableHrs: customBillableHrsColumn,
        workingHrs: customWorkinghrsColumn,
        leavesAvailed: customLeavesAvailedColumn,
        status: customStatusColumn,
        l3ManagerName: customDntLeaderColumn,
        reportingManager: customReportingManagerColumn,
        location: customLocationColumn
      }"
    ></emerald-datatable>
  </ng-container>

  <ng-template #noDataTemplate>
    <section class="records-container" aria-label="Records section">
      <div class="empty-state">
        <ng-container *ngIf="isDataLoaded">
          <h2 class="empty-state-title">{{ errorMsg }}</h2>
        </ng-container>
        <img
          [src]="imageSrc"
          alt="No records illustration"
          class="empty-state-image"
        />
      </div>
    </section>
  </ng-template>

  <ng-template #customSelectColumn let-level="level" let-eachRow="eachRow">
    <div *ngIf="shouldShowCheckbox(eachRow); else emptyCell">
      <emerald-checkbox
        [title]="'Select Item'"
        [checked]="eachRow?.selected || false"
        [forceRefresh]="true"
        (onChange)="onCheckboxChange(eachRow, $event)"
      >
      </emerald-checkbox>
    </div>
    <ng-template #emptyCell>
      <div class="empty-checkbox-cell"></div>
    </ng-template>
  </ng-template>

  <ng-template #customNameColumn let-level="level" let-eachRow="eachRow">
    <div class="member">
      <div class="name">
        <a class="job-title" (click)="navigateToContractorProfile(eachRow?.employeeId)">{{ eachRow?.employeeName }}</a>
      </div>
      <div class="title">
        <span class="emp-id">{{ eachRow?.employeeId }}</span><span *ngIf="eachRow?.jobTitle"> · {{ eachRow?.jobTitle }}</span>
      </div>
    </div>
  </ng-template>

  <ng-template #customDntLeaderColumn let-eachRow="eachRow">
    <span class="ts-ellipsis" (mouseenter)="showTip($event, eachRow?.l3ManagerName)" (mouseleave)="hideTip()">{{ eachRow?.l3ManagerName }}</span>
  </ng-template>

  <ng-template #customReportingManagerColumn let-eachRow="eachRow">
    <span class="ts-ellipsis" (mouseenter)="showTip($event, eachRow?.reportingManager)" (mouseleave)="hideTip()">{{ eachRow?.reportingManager }}</span>
  </ng-template>

  <ng-template #customLocationColumn let-eachRow="eachRow">
    <span class="ts-ellipsis" (mouseenter)="showTip($event, eachRow?.location)" (mouseleave)="hideTip()">{{ eachRow?.location }}</span>
  </ng-template>

  <ng-template #customEmployeeStatusColumn let-level="level" let-eachRow="eachRow">
    <div class="employee-status">
      <span class="ts-pill" [ngClass]="eachRow?.employeeStatus === 'Active' ? 'ok' : 'cold'">
        <span class="dot"></span>{{ eachRow?.employeeStatus }}
      </span>
      <a
        *ngIf="eachRow?.employeeStatus === 'Inactive'"
        class="exclude-link"
        (click)="excludeFromTimesheets(eachRow)"
      >
        Don't include in timesheets
      </a>
    </div>
  </ng-template>

  <ng-template #customLeavesAvailedColumn let-eachRow="eachRow">
    {{ eachRow?.leavesAvailed }}
  </ng-template>

  <ng-template #customCalenderColumn let-level="level" let-eachRow="eachRow">
    <div class="calendar">
      <div class="calendar-icon" title="Get Calender">
        <emerald-icon [icon]="'date_range'" (click)="openTimesheetCalendar(eachRow)">
        </emerald-icon>
      </div>
    </div>
  </ng-template>

  <ng-template #customBillableHrsColumn let-level="level" let-eachRow="eachRow">
    <span>
      {{ eachRow?.billableHrs }}{{ getHoursSuffix() || '' }}
    </span>
  </ng-template>

  <ng-template #customWorkinghrsColumn let-level="level" let-eachRow="eachRow">
    {{ eachRow?.workingHrs }}{{ getHoursSuffix() || '' }}
  </ng-template>

  <ng-template #customStatusColumn let-level="level" let-eachRow="eachRow">
    <div class="status-container">
      <span
        class="ts-pill"
        [ngClass]="{
          'ok': eachRow?.status === TimesheetStatus.Approved,
          'crit': eachRow?.status === TimesheetStatus.Rejected,
          'warn': eachRow?.status === TimesheetStatus.PendingApproval,
          'cold': !eachRow?.status || (eachRow?.workingHrs === 0 && eachRow?.billableHrs === 0)
        }"
      >
        <span class="dot"></span>
        <ng-container *ngIf="eachRow?.status; else pendingSubmissionStatus">
          {{ eachRow?.status }}
        </ng-container>
        <ng-template #pendingSubmissionStatus>
          <ng-container *ngIf="!eachRow?.status || (eachRow?.workingHrs === 0 && eachRow?.billableHrs === 0)">
            {{ TimesheetStatus.PendingSubmission }}
          </ng-container>
        </ng-template>
      </span>
    </div>
  </ng-template>

  <div *ngIf="isTimesheetCalendarOpen" class="modal-container">
    <div class="dim-background" (click)="closeTimesheetCalendar()"></div>
    <div class="modal-content">
      <app-timesheet-calendar
        *ngIf="isTimesheetCalendarOpen"
        [componentName]="componentName"
        [candidateDetails]="selectedRowData"
        [selectedyear]="selectedyear"
        [selectedmonth]="selectedmonth.toString().includes('-') ? selectedmonth.toString().split('-')[0] : selectedmonth"
        (refreshTimesheet)="getTimesheetDetails()"
        (closeComponent)="closeTimesheetCalendar()"
      ></app-timesheet-calendar>
    </div>
  </div>
  <app-confirmation-dialog
    [isOpen]="showSubmitConfirmation"
    [title]="TIMESHEET_CONSTANTS.CONFIRMATION_DIALOG.TITLE"
    [message]="confirmationDialogMessage"
    [submitLabel]="TIMESHEET_CONSTANTS.CONFIRMATION_DIALOG.SUBMIT_LABEL"
    [cancelLabel]="TIMESHEET_CONSTANTS.CONFIRMATION_DIALOG.CANCEL_LABEL"
    (confirm)="onConfirmSubmit()"
    (cancel)="onCancelSubmit()">
  </app-confirmation-dialog>
  <app-confirmation-dialog
    [isOpen]="showExcludeConfirmation"
    [title]="TIMESHEET_CONSTANTS.EXCLUDE_CONFIRMATION_DIALOG.TITLE"
    [message]="TIMESHEET_CONSTANTS.EXCLUDE_CONFIRMATION_DIALOG.MESSAGE"
    [submitLabel]="TIMESHEET_CONSTANTS.EXCLUDE_CONFIRMATION_DIALOG.SUBMIT_LABEL"
    [cancelLabel]="TIMESHEET_CONSTANTS.EXCLUDE_CONFIRMATION_DIALOG.CANCEL_LABEL"
    (confirm)="onConfirmExclude()"
    (cancel)="onCancelExclude()">
  </app-confirmation-dialog>

  <emerald-modal
    [opened]="showStatusChangeDialog"
    (close)="closeStatusChangeDialog()"
  >
    <div class="status-change-dialog">
      <div class="dialog-content">
        <div *ngIf="statusChangeDialogData.length === 1" class="employee-message">
          <p>{{ statusChangeDialogData[0].employeeName }} with employee ID {{ statusChangeDialogData[0].employeeId }} has already been approved.</p>
        </div>
      </div>
      <div class="dialog-actions">
        <emerald-button
          [label]="'OK'"
          [type]="'Primary'"
          (onClick)="closeStatusChangeDialog()">
        </emerald-button>
      </div>
    </div>
  </emerald-modal>

  <app-modal-wrapper *ngIf="showContractorProfile" [showModal]="showContractorProfile">
    <app-vendor-contractor-profile
      [contractorId]="contractorId"
      (close)="showContractorProfile = false"
    ></app-vendor-contractor-profile>
  </app-modal-wrapper>

  <div class="ts-hovertip" *ngIf="hoverTip.show" [style.left.px]="hoverTip.x" [style.top.px]="hoverTip.y">
    {{ hoverTip.text }}
  </div>

</div>